import React, { useState, useEffect } from "react";
import { db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import QuestionHistory from "./QuestionHistory";
import { ListChecks } from "lucide-react";

export default function QuestionHistoryAnswers() {
  const [template, setTemplate] = useState(null);
  const [selectedField, setSelectedField] = useState(null);

  useEffect(() => {
    const fetchGoals = async () => {
      try {
        const ref = doc(db, "goals", "currentGoals");
        const snap = await getDoc(ref);
        if (snap.exists()) {
          const data = snap.data();
          const grouped = (data.sections || []).map((sectionTitle) => ({
            title: sectionTitle,
            fields: (data.goals || [])
              .filter((g) => g.category === sectionTitle)
              .map((g) => ({
                label: g.question,
                name: g.uid,
                type: g.entryType || g.type || "number",
              })),
          }));
          setTemplate({ sections: grouped });
        }
      } catch (err) {
        console.error("Błąd podczas pobierania goals:", err);
      }
    };
    fetchGoals();
  }, []);

  return (
    <div className="p-4">
      <div className="flex items-center gap-2 mb-4">
        <ListChecks className="text-green-600" size={28} />
        <h2 className="text-2xl font-bold text-green-700">Historia odpowiedzi</h2>
      </div>
      {!selectedField ? (
        <div>
          {template && Array.isArray(template.sections) ? (
            template.sections.map((section) => (
              <div key={section.title} className="mb-6">
                <h3 className="text-lg font-bold text-emerald-800 dark:text-green-200 border-b pb-1 mb-2">
                  {section.title}
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                  {section.fields.map((field) => (
                    <button
                      key={field.name}
                      className="text-left bg-emerald-50 dark:bg-gray-900 hover:bg-emerald-100 dark:hover:bg-emerald-800 border border-emerald-200 dark:border-gray-700 px-3 py-2 rounded-lg shadow-sm text-emerald-900 dark:text-green-100 mb-2 transition"
                      onClick={() => setSelectedField(field)}
                    >
                      {field.label}
                      <span className="block text-xs text-gray-400 mt-1">
                        {field.type === "checkbox"
                          ? "Typ: Tak/Nie"
                          : field.type === "number"
                          ? "Typ: Liczba"
                          : "Typ: Notatka"}
                      </span>
                    </button>
                  ))}
                </div>
              </div>
            ))
          ) : (
            <div>Ładowanie sekcji...</div>
          )}
        </div>
      ) : (
        <QuestionHistory
          fieldName={selectedField.name}
          label={selectedField.label}
          type={selectedField.type}
          onClose={() => setSelectedField(null)}
        />
      )}
    </div>
  );
}
